import {
  Button,
  CircularProgress,
  Radio,
  Switch,
  TextareaAutosize,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { db, storage } from "../../../firebase";
import firebase from "firebase";
import Loading from "../../Atoms/loading/Loading";
import "./Homepage.css";
import Compress from "react-image-file-resizer";
import AboutUsTemplate from "./AboutUsTemplate";
import axios from "axios";
import DigitalCard from "./DigitalCard";

function Homepage() {
  const [digitalDashboard, setDigitalDashboard] = useState([]);
  const [loading, setLoading] = useState(false);
  const [choice, setChoice] = useState("");
  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(undefined);
  const [reload, setReload] = useState(false);
  const [makeDisable, setMakeDisable] = useState(false);
  const [aboutJainSamaj, setAboutJainSamaj] = useState("");
  const [btnLoadingJainCommunity, setBtnLoadingJainCommunity] = useState(false);
  const [change, setChange] = useState(false);
  const [priority, setPriority] = useState(undefined);

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");

  const [aboutJainHospital, setAboutJainHospital] = useState(null);
  const [hospitalLoading, setHospitalLoading] = useState(true);

  const [aboutJainSchool, setAboutJainSchool] = useState(null);
  const [schoolLoading, setSchoolLoading] = useState(true);

  const [aboutJainTemple, setAboutJainTemple] = useState(null);
  const [templeLoading, setTempleLoading] = useState(true);

  const [reloadAboutUs, setReloadAboutUs] = useState(false);

  const [contactUsLoading, setContactUsLoading] = useState(false);

  const [celebrationsLoading, setCelebrationsLoading] = useState(false);
  const [celebrationUpdateDate, setCelebrationUpdateDate] = useState("");

  const [celebrationsVisible, setCelebrationsVisible] = useState(false);
  const [visibleLoading, setVisibleLoading] = useState(false);
  const [error, setError] = useState(false);

  const fileSetter = (e) => {
    if (!e.target.files) {
      return;
    }
    const f = e.target.files[0];

    const image = new Image();

    var objectUrl = URL.createObjectURL(f);

    image.onload = function () {
      Compress.imageFileResizer(
        f,
        this.width,
        this.height,
        "PNG",
        30,
        0,
        (uri) => {
          setFile(uri);
        },
        "file"
      );

      URL.revokeObjectURL(objectUrl);
    };

    image.src = objectUrl;
  };

  const addHandler = async () => {
    setMakeDisable(true);
    try {
      let fileURL = "";
      let fileName = new Date().toISOString();
      if (choice === "Image") {
        const storageRef = storage.ref();
        const ref = storageRef.child(`/DigitalBoard/${fileName}`);
        await ref.put(file);
        fileURL = await ref.getDownloadURL();
      }

      await db
        .collection("HomePageData")
        .doc("ScreenData")
        .update({
          digitalBoard: firebase.firestore.FieldValue.arrayUnion({
            type: choice === "Text" ? 0 : 1,
            info: choice === "Text" ? text : fileURL,
            fileName: choice === "Text" ? "" : fileName,
            priority: Number(priority),
          }),
        });
      setFile(null);
      setChoice("");
      setPreview(undefined);
      setText("");
      setReload((p) => !p);
      setMakeDisable(false);
      setPriority(undefined);
    } catch (e) {
      setMakeDisable(false);
      console.log(e);
    }
  };

  const removeHandler = async (i, item) => {
    if (item.type === 1) {
      const storageRef = storage.ref(`DigitalBoard/${item.fileName}`);
      await storageRef.delete();
    }

    await db
      .collection("HomePageData")
      .doc("ScreenData")
      .update({
        digitalBoard: digitalDashboard.filter((item, ind) => ind !== i),
      });
    setDigitalDashboard((prev) => prev.filter((item, ind) => ind !== i));
    setReload((p) => !p);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const snapShot = await db
          .collection("HomePageData")
          .doc("ScreenData")
          .get();
        setDigitalDashboard(
          snapShot.data().digitalBoard.sort((a, b) => b.priority - a.priority)
        );
        setCelebrationUpdateDate(snapShot.data().celebrationsLastUpdatedOn);
        setCelebrationsVisible(snapShot.data().celebrationsVisible);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    };
    fetchData();
  }, [reload]);

  useEffect(() => {
    if (!file) {
      return setPreview(undefined);
    }

    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    // console.log(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  useEffect(() => {
    setHospitalLoading(true);
    setBtnLoadingJainCommunity(true);
    setSchoolLoading(true);
    setTempleLoading(true);

    const fetchData = async () => {
      try {
        const aboutUsSnapShot = await db
          .collection("HomePageData")
          .doc("AboutUsData")
          .get();
        setAboutJainSamaj(aboutUsSnapShot.data().aboutJainSamaj);
        setAboutJainHospital(aboutUsSnapShot.data().aboutJainHospital);
        setAboutJainSchool(aboutUsSnapShot.data().aboutJainSchool);
        setAboutJainTemple(aboutUsSnapShot.data().aboutJainTemple);
        setAddress(aboutUsSnapShot.data().address);
        setEmail(aboutUsSnapShot.data().emailAddress);
        setPhone(aboutUsSnapShot.data().phoneNumber);
        // console.log(aboutUsSnapShot.data());
        // setHospitalLoading(false);
        setBtnLoadingJainCommunity(false);
      } catch (e) {
        console.log(e);
        // setHospitalLoading(false);
        setBtnLoadingJainCommunity(false);
      }
    };

    fetchData();
  }, [reloadAboutUs]);

  useEffect(() => {
    if (!aboutJainHospital) {
      return;
    }
    setHospitalLoading(false);
  }, [aboutJainHospital]);

  useEffect(() => {
    if (!aboutJainSchool) {
      return;
    }
    setSchoolLoading(false);
  }, [aboutJainSchool]);

  useEffect(() => {
    if (!aboutJainTemple) {
      return;
    }
    setTempleLoading(false);
  }, [aboutJainTemple]);

  // console.log(aboutJainHospital);

  const aboutJainSamajHandler = async () => {
    setBtnLoadingJainCommunity(true);
    try {
      await db
        .collection("HomePageData")
        .doc("AboutUsData")
        .update({ aboutJainSamaj });
    } catch (e) {
      console.log(e);
    }
    setBtnLoadingJainCommunity(false);
    setChange(false);
  };

  const handleContantUs = async () => {
    setContactUsLoading(true);
    try {
      await db.collection("HomePageData").doc("AboutUsData").update({
        address,
        emailAddress: email,
        phoneNumber: phone,
      });
    } catch (e) {
      console.log(e);
    }
    setContactUsLoading(false);
  };

  const celebrationsHandler = async () => {
    setCelebrationsLoading(true);
    setError(false);
    try {
      await axios.get("https://arham-app.herokuapp.com/updateAllCelebrations");
      // console.log(resp);

      let date = new Date();
      const dateString = date.toLocaleString();

      await db.collection("HomePageData").doc("ScreenData").update({
        celebrationsLastUpdatedOn: dateString,
      });

      setCelebrationUpdateDate(dateString);
    } catch (e) {
      console.log(e);
      setError(true);
    }
    setCelebrationsLoading(false);
  };

  const celebrationVisibleHandler = async () => {
    setVisibleLoading(true);
    try {
      await db
        .collection("HomePageData")
        .doc("ScreenData")
        .update({ celebrationsVisible: !celebrationsVisible });
      setCelebrationsVisible((p) => !p);
    } catch (e) {
      console.log(e);
    }
    setVisibleLoading(false);
  };

  // console.log(digitalDashboard);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <h1 className="hompage__h1">Digital-Board</h1>
          <div className="homepage">
            {digitalDashboard.map((item, i) => (
              <DigitalCard
                key={i}
                item={item}
                i={i}
                digitalDashboard={[...digitalDashboard]}
                reloadState={[reload, setReload]}
                removeHandler={removeHandler}
              />
            ))}
          </div>

          <div className="homepage__upload">
            <label>
              Text:
              <Radio
                checked={choice === "Text"}
                onChange={() => setChoice("Text")}
              />
            </label>
            <label>
              Image:
              <Radio
                checked={choice === "Image"}
                onChange={() => setChoice("Image")}
              />
            </label>
            {choice === "Text" && (
              <>
                <div>
                  <TextareaAutosize
                    rowsMin={5}
                    rowsMax={5}
                    placeholder="Description"
                    onChange={(e) => setText(e.target.value)}
                  />
                </div>
                <input
                  type="number"
                  placeholder="Priority (Integer)"
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                />
              </>
            )}
            {choice === "Image" && (
              <>
                <div>
                  <input
                    type="file"
                    accept="image/*"
                    id="homepage__uploadInput"
                    hidden
                    onChange={fileSetter}
                  />
                </div>
                <label
                  htmlFor="homepage__uploadInput"
                  style={{ cursor: "pointer" }}
                >
                  Choose an image
                </label>
                {preview && (
                  <div className="homepage__uploadImageContainer">
                    <img src={preview} alt="" />
                  </div>
                )}
                <input
                  type="number"
                  value={priority}
                  placeholder="Priority (Integer)"
                  onChange={(e) => setPriority(e.target.value)}
                />
              </>
            )}
            <div style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={addHandler}
                style={{ marginRight: "10px" }}
                disabled={!((file || text) && !makeDisable && priority)}
              >
                Add
              </Button>
            </div>
          </div>
          {/* -----------------About us-------------------- */}
          <div className="AboutUs" style={{ paddingBottom: "10%" }}>
            <div>
              <h1 style={{ textAlign: "left", margin: "20px 10px" }}>
                Update Celebrations
              </h1>
              <div
                style={{
                  width: "fit-content",
                  margin: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <span style={{ fontSize: "17px", fontWeight: "bold" }}>
                    Celebrations Visible?
                  </span>
                  <Switch
                    checked={celebrationsVisible}
                    onChange={celebrationVisibleHandler}
                  />
                  <div style={{ width: "18px", height: "18px" }}>
                    {visibleLoading && (
                      <CircularProgress
                        style={{ height: "16px", width: "16px" }}
                      />
                    )}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <span style={{ fontSize: "17px", fontWeight: "bold" }}>
                    Today's Celebrations:
                  </span>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={celebrationsLoading}
                    onClick={celebrationsHandler}
                    style={{
                      padding: "0",
                      textTransform: "none",
                      margin: "5px",
                    }}
                  >
                    Update
                  </Button>
                  <div
                    style={{
                      margin: "5px 10px",
                      height: "18px",
                      width: "150px",
                      // border: "1px solid black",
                    }}
                  >
                    {celebrationsLoading && (
                      <CircularProgress
                        style={{ height: "16px", width: "16px" }}
                      />
                    )}
                    {error && (
                      <p
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          fontSize: "15px",
                          backgroundColor: "yellow",
                        }}
                      >
                        Error from backend
                      </p>
                    )}
                  </div>
                </div>

                <p
                  style={{
                    margin: "5px 0",
                    fontSize: "17px",
                    textAlign: "start",
                  }}
                >
                  Last updated on
                  <b style={{ color: "#f76b1c" }}> {celebrationUpdateDate}</b>
                </p>
              </div>
            </div>
            <div className="AboutUs__community">
              <h1 style={{ textAlign: "left", margin: "20px 10px" }}>
                Community
              </h1>
              <textarea
                rows="6"
                placeholder="About Jain Samaj"
                value={aboutJainSamaj}
                onChange={(e) => {
                  setAboutJainSamaj(e.target.value);
                  setChange(true);
                }}
                style={{
                  width: "90%",
                  padding: "5px",
                  fontSize: "18px",
                  fontFamily: "inherit",
                }}
              />

              <div style={{ margin: "10px 0" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={aboutJainSamajHandler}
                  disabled={btnLoadingJainCommunity || !change}
                >
                  Submit
                </Button>
              </div>
            </div>

            {hospitalLoading ? (
              <div
                style={{
                  margin: "30px 0",
                  height: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <AboutUsTemplate
                type="Hospital"
                data={aboutJainHospital}
                relodAboutUsState={[reloadAboutUs, setReloadAboutUs]}
              />
            )}

            {schoolLoading ? (
              <div
                style={{
                  margin: "30px 0",
                  height: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <AboutUsTemplate
                type="School"
                data={aboutJainSchool}
                relodAboutUsState={[reloadAboutUs, setReloadAboutUs]}
              />
            )}

            {templeLoading ? (
              <div
                style={{
                  margin: "30px 0",
                  height: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <AboutUsTemplate
                type="Temple"
                data={aboutJainTemple}
                relodAboutUsState={[reloadAboutUs, setReloadAboutUs]}
              />
            )}

            <div className="AboutUs__contact">
              <h1 style={{ textAlign: "left", margin: "20px 10px" }}>
                Contact Us
              </h1>
              <label>
                <p>Phone</p>
                <input
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </label>
              <label>
                <p>Email</p>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>

              <label>
                <p>Address</p>
                <input
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </label>
              <div>
                {contactUsLoading ? (
                  <CircularProgress />
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleContantUs}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Homepage;
